import { LocationsLabels } from 'libs/shared-lib/interfaces/partner-web/locations';
import { m070c040DealerContact } from '../../shared/shared.fr';

export const LOCATIONS_LABELS_FR: LocationsLabels = {
    headline: 'Nos sites compétents',
    m070c040DealerContact,
};
